import { render } from "./service-blocked-modal.vue?vue&type=template&id=dd824018&ts=true"
import script from "./service-blocked-modal.ts?vue&type=script&lang=ts&external"
export * from "./service-blocked-modal.ts?vue&type=script&lang=ts&external"

import "./service-blocked-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__